<template>
	
	<!-- Main Sidebar -->
	<component :is="navbarFixed ? 'a-affix' : 'div'" :offset-top="top">

		<!-- Layout Header -->
		<a-layout-header>
			<a-row type="flex" justify="space-between" align="middle" style="width: 100%;">

				<!-- Header Breadcrumbs & Title Column -->
				<a-col :span="24" :md="6">

					<!-- Header Breadcrumbs -->
					<a-breadcrumb>
						<a-breadcrumb-item><router-link to="/"></router-link></a-breadcrumb-item>
						<a-breadcrumb-item>{{ this.$route.name }}</a-breadcrumb-item>
					</a-breadcrumb>
					<!-- / Header Breadcrumbs -->
					<!-- Header Page Title -->
					<div class="ant-page-header-heading">
						<span class="ant-page-header-heading-title">{{ this.$route.name }}</span>
					</div>
					<!-- / Header Page Title -->
					
				</a-col>
				<!-- / Header Breadcrumbs & Title Column -->
				
				<!-- Header Control Column -->
				<a-col :span="24" :md="18" class="header-control">

					<!-- Header Control Buttons -->
					<a-button type="link" class="sidebar-toggler" @click="$emit('toggleSidebar', ! sidebarCollapsed) , resizeEventHandler()">
						<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/></svg>
					</a-button>
					<router-link to="/sign-in" class="btn-sign-in" @click="e => e.preventDefault()" v-if="!info">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z" fill="#111827"/>
						</svg>
						<span>Sign In</span>
					</router-link>
					<a-dropdown v-if="info" :trigger="['click']" placement="bottomRight">
						<div class="user-avatar-wrapper">
							<div class="user-avatar">
								{{ info.user_name ? info.user_name.charAt(0) : 'U' }}
							</div>
							<div class="user-info">
								<span class="user-name">{{ info.user_name }}</span>
								<span class="user-role">管理员</span>
							</div>
						</div>
						
						<div slot="overlay" class="user-dropdown-menu">
							<div class="dropdown-header">
								<div class="dropdown-title">我的账户</div>
								<div class="dropdown-phone">{{ info.mobile || '-' }}</div>
							</div>
							<div class="dropdown-divider"></div>
							<div class="dropdown-item" @click="goToSettings">
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
									<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
									<circle cx="12" cy="12" r="3"/>
								</svg>
								<span>账户设置</span>
							</div>
							<div class="dropdown-divider"></div>
							<div class="dropdown-item logout-item" @click="user_logout">
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
									<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
									<polyline points="16 17 21 12 16 7"/>
									<line x1="21" y1="12" x2="9" y2="12"/>
								</svg>
								<span>退出登录</span>
							</div>
						</div>
					</a-dropdown>
					
					<!-- / Header Control Buttons -->

				</a-col>
				<!-- / Header Control Column -->

			</a-row>
		</a-layout-header>
		<!--  /Layout Header -->

	</component>
	<!-- / Main Sidebar -->

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
	const notificationsData = [
		{
			title: 'New message from Sophie',
			img: 'images/face-1.jpg',
			time: '13 minutes ago',
		},
		{
			title: 'New album by Travis Scott',
			svg: `<svg width="20" height="20" viewBox="0 0 107 107" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<title>logo-spotify</title>
					<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g id="logo-spotify" fill="#2EBD59" fill-rule="nonzero">
							<path d="M53.5,0 C23.9517912,0 0,23.9517912 0,53.5 C0,83.0482088 23.9517912,107 53.5,107 C83.0482088,107 107,83.0482088 107,53.5 C107,23.9554418 83.0482088,0.00365063118 53.5,0 Z M78.0358922,77.1597407 C77.0757762,78.7368134 75.0204708,79.2296486 73.4506994,78.2695326 C60.8888775,70.5922552 45.0743432,68.8582054 26.4524736,73.1111907 C24.656363,73.523712 22.8675537,72.3993176 22.458683,70.6032071 C22.0461617,68.8070966 23.1669055,67.0182873 24.9666667,66.6094166 C45.3444899,61.9548618 62.8273627,63.9590583 76.9297509,72.5745479 C78.4995223,73.5419652 78.9996588,75.5899693 78.0358922,77.1597407 L78.0358922,77.1597407 Z M84.5814739,62.5973729 C83.373115,64.5614125 80.8030706,65.1747185 78.8426817,63.9700102 C64.4664961,55.1318321 42.5408052,52.5727397 25.5325145,57.7347322 C23.3275333,58.4027977 20.9984306,57.1579324 20.3267144,54.9566018 C19.6622996,52.7516206 20.9071648,50.4261685 23.1084954,49.7544524 C42.5371546,43.858683 66.6933811,46.7134766 83.2051859,56.8622313 C85.1692255,58.0705902 85.7898328,60.636984 84.5814739,62.5973729 Z M85.1436711,47.4253497 C67.8980894,37.1853292 39.4523712,36.2434664 22.9880246,41.2375299 C20.3449676,42.0406687 17.5485841,40.5475606 16.7490959,37.9045036 C15.9496076,35.2614466 17.4390652,32.4650631 20.0857728,31.6619243 C38.9850904,25.9267827 70.3987718,27.0329239 90.2509041,38.8171614 C92.627465,40.2299556 93.4087001,43.3001365 91.9995565,45.6730467 C90.5940635,48.0532583 87.5165814,48.838144 85.1436711,47.4253497 Z" id="Shape"></path>
						</g>
					</g>
				</svg>`,
			time: '1 day ago',
		},
		{
			title: 'Payment completed',
			svg: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill="#2563EB" d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"/>
					<path fill="#2563EB" fill-rule="evenodd" clip-rule="evenodd" d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"/>
				</svg>`,
			time: '2 days ago',
		},
	] ;

	export default ({
		props: {
			// Header fixed status.
			navbarFixed: {
				type: Boolean,
				default: false,
			},

			// Sidebar collapsed status.
			sidebarCollapsed: {
				type: Boolean,
				default: false,
			},

			// Header notifications data.
			notificationsData: {
				type: Array,
				default: () => notificationsData,
			},
		},
		computed: {
			...mapGetters('main/user',[
				'info',
			]),
		},
		data() {
			return {
				// Fixed header/sidebar-footer ( Affix component ) top offset.
				top: 0,

				// Search input loading status.
				searchLoading: false,

				// The wrapper element to attach dropdowns to.
				wrapper: document.body,
			}
		},
		created() {
			console.log(this.$store);
		},
		methods: {
			...mapActions('main/user', ['logout']),

			resizeEventHandler(){
				this.top = this.top ? 0 : -0.01 ;
				// To refresh the header if the window size changes.
				// Reason for the negative value is that it doesn't activate the affix unless
				// scroller is anywhere but the top of the page.
			},
			onSearch(value){
			},
			user_logout() {
				this.logout().then(res => {
					this.$router.replace('/sign-in')
				})
			},
			goToSettings() {
				this.$router.push('/users/wode')
			}
		},
		mounted: function(){
			// Set the wrapper to the proper element, layout wrapper.
			this.wrapper = document.getElementById('layout-dashboard') ;
		},
		created() {
			// Registering window resize event listener to fix affix elements size
			// error while resizing.
			window.addEventListener("resize", this.resizeEventHandler);
		},
		destroyed() {
			// Removing window resize event listener.
			window.removeEventListener("resize", this.resizeEventHandler);
		},
	})

</script>

<style lang="scss">
// ============================================
// Header Styles - Facebook Engineering Standard
// ============================================

$primary: #2563EB;
$text-primary: #111827;
$text-secondary: #6B7280;
$border-color: #E5E7EB;
$danger: #EF4444;

// 用户头像区域
.user-avatar-wrapper {
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 12px;
	border-radius: 12px;
	transition: background-color 0.15s ease;
	
	&:hover {
		background-color: rgba(0, 0, 0, 0.05);
	}
}

.user-avatar {
	width: 36px;
	height: 36px;
	border-radius: 12px;
	background: linear-gradient(135deg, $primary 0%, #1D4ED8 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	color: #FFFFFF;
	font-weight: 700;
	font-size: 14px;
	transition: all 0.15s ease;
	font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
	flex-shrink: 0;
	
	&:hover {
		box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
	}
}

.user-info {
	display: flex;
	flex-direction: column;
	gap: 2px;
	
	.user-name {
		font-size: 14px;
		font-weight: 500;
		color: $text-primary;
		font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
		line-height: 1.2;
	}
	
	.user-role {
		font-size: 12px;
		color: $text-secondary;
		line-height: 1.2;
	}
}

// Header control 区域
.header-control {
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	gap: 8px;
	
	.sidebar-toggler {
		display: block;
		
		@media (min-width: 992px) {
			display: none;
		}
	}
}

// 面包屑样式
.ant-breadcrumb {
	font-size: 12px;
	
	a {
		color: $text-secondary;
		
		&:hover {
			color: $primary;
		}
	}
}

// 页面标题样式
.ant-page-header-heading {
	margin-top: 4px;
	
	.ant-page-header-heading-title {
		font-size: 18px;
		font-weight: 600;
		color: $text-primary;
		font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
		letter-spacing: -0.01em;
	}
}
</style>

<style lang="scss">
// ============================================
// 下拉菜单全局样式 - 必须是非scoped才能影响弹出层
// ============================================

$primary: #2563EB;
$text-primary: #111827;
$text-secondary: #6B7280;
$border-color: #E5E7EB;
$danger: #EF4444;

// 下拉菜单样式
.user-dropdown-menu {
	min-width: 224px;
	width: 224px;
	padding: 8px;
	border-radius: 16px;
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
	border: 1px solid $border-color;
	overflow: hidden;
	background: #FFFFFF;
	
	.dropdown-header {
		padding: 12px;
		
		.dropdown-title {
			font-size: 16px;
			font-weight: 500;
			color: $text-primary;
			margin-bottom: 4px;
			font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
		}
		
		.dropdown-phone {
			font-size: 14px;
			color: $text-secondary;
		}
	}
	
	.dropdown-divider {
		height: 1px;
		background-color: $border-color;
		margin: 8px 0;
	}
	
	.dropdown-item {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 12px;
		color: $text-secondary;
		font-size: 14px;
		font-weight: 400;
		transition: all 0.15s ease;
		font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
		border-radius: 12px;
		cursor: pointer;
		
		svg {
			flex-shrink: 0;
			color: $text-secondary;
		}
		
		&:hover {
			background-color: rgba(0, 0, 0, 0.05);
			color: $text-primary;
			
			svg {
				color: $text-primary;
			}
		}
		
		&.logout-item {
			color: $danger;
			
			svg {
				color: $danger;
			}
			
			&:hover {
				background-color: rgba(239, 68, 68, 0.1);
				color: $danger;
				
				svg {
					color: $danger;
				}
			}
		}
	}
}
</style>
